import { render, staticRenderFns } from "./Report-overdue-members.vue?vue&type=template&id=a54ffdac"
import script from "./Report-overdue-members.vue?vue&type=script&lang=js"
export * from "./Report-overdue-members.vue?vue&type=script&lang=js"
import style0 from "./Report-overdue-members.vue?vue&type=style&index=0&id=a54ffdac&prod&lang=scss"
import style1 from "./Report-overdue-members.vue?vue&type=style&index=1&id=a54ffdac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports